<template>
  <div :class="$style.overlayContent">
    <div :class="[$style[iconAlignment], $style.wrapper]">
      <VsIcon
        v-if="icon"
        :icon="icon"
        :class="[$style.icon]"
      />
      <div :class="$style.textWrapper">
        <h4 :class="[$style.marginTop1, $style.marginBottom1]">
          <slot name="title" />
        </h4>
        <p :class="[$style.marginTop1, $style.marginBottom1]">
          <slot name="message" />
        </p>
      </div>
    </div>

    <div :class="[$style.marginTop4, $style.content]">
      <slot name="content" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import VsIcon from '@/scripts/Components/Molecules/VsIcon.vue';

export default Vue.extend({
  components: {
    VsIcon,
  },
  props: {
    icon: {
      type: String,
      default: undefined,
    },
    iconAlignment: {
      type: String as PropType<'left' | 'top'>,
      default: 'top',
    },
  },
});
</script>

<style lang="scss" module>
@import '~@/stylesheets/exports/_component-entry';

.overlayContent {
  color: white;
  text-align: center;

  $widerMobileScreenBreakpoint: 360px;

  font-size: 3.9vw;
  @media screen and (min-width: $widerMobileScreenBreakpoint) {
    font-size: 1em;
  }

  $margin: 0.25em;
  .marginTop1 { margin-top: $margin; }
  .marginTop4 { margin-top: $margin * 4; }
  .marginBottom1 { margin-bottom: $margin; }
  .marginBottom4 { margin-bottom: $margin * 4; }
}

.icon:global(.vs-icon) {
  font-size: 5vw;
  @include media-breakpoint-up(sm) {
    font-size: 24px;
  }
}

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper.left {
  flex-direction: row;
  .textWrapper {
    text-align: left;
  }
  .icon {
    margin-right: 0.4em;
  }
}
.wrapper.top {
  flex-direction: column;
  .textWrapper {
    text-align: center;
  }
  .icon {
    margin-bottom: 0.1em;
  }
}
</style>
